// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddEmployeeToGroup_flexContainer__zRQJg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
}

.AddEmployeeToGroup_button__g5Pae {
  max-width: 60px;
  border-radius: 20%;
  border: 2px solid #f2f0f0;
}

.AddEmployeeToGroup_icon__u4EdB {
  color: #4d4d4d;
}

.AddEmployeeToGroup_title__ZjNFw {
  font-family: "Inter";
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
}

.AddEmployeeToGroup_userMenu__uJ7Yd {
  display: flex;
  gap: 40px;
}

.AddEmployeeToGroup_djelatnici-grid__St1Ka {
  margin-top: 2%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  width: 90%;
}
.AddEmployeeToGroup_buttonContainer__BeIp4 {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  gap: 20px;
}

.AddEmployeeToGroup_cancelButton__JMSsn {
  max-width: 250px;
  min-width: 200px;
  height: 52px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  background: #ebebeb;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
  color: #808080;
  cursor: pointer;
}
.AddEmployeeToGroup_nextButton__Z30lB {
  max-width: 250px;
  min-width: 200px;
  height: 52px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  background: #cb9c2d;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.AddEmployeeToGroup_disabledBtn__U05zT {
  cursor: not-allowed !important;
  background: #cbba92 !important;
}

@media (max-width: 768px) {
  .AddEmployeeToGroup_djelatnici-grid__St1Ka {
    grid-template-columns: repeat(2, 1fr);
  }

  .AddEmployeeToGroup_userMenu__uJ7Yd {
    flex-direction: column;
    gap: 10px;
  }

  .AddEmployeeToGroup_cancelButton__JMSsn,
  .AddEmployeeToGroup_nextButton__Z30lB {
    max-width: 80%;
    padding: 12px;
  }
  .AddEmployeeToGroup_selectContainer__OCpQ4 {
    display: none;
  }
  .AddEmployeeToGroup_userMenu__uJ7Yd {
    display: none; /* needs to be added back later */
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/IPDTeam/AddEmployeeToGroup/AddEmployeeToGroup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,cAAc;IACd,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa,EAAE,iCAAiC;EAClD;AACF","sourcesContent":[".flexContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 40px;\n}\n\n.button {\n  max-width: 60px;\n  border-radius: 20%;\n  border: 2px solid #f2f0f0;\n}\n\n.icon {\n  color: #4d4d4d;\n}\n\n.title {\n  font-family: \"Inter\";\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n}\n\n.userMenu {\n  display: flex;\n  gap: 40px;\n}\n\n.djelatnici-grid {\n  margin-top: 2%;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  width: 90%;\n}\n.buttonContainer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 10px;\n  gap: 20px;\n}\n\n.cancelButton {\n  max-width: 250px;\n  min-width: 200px;\n  height: 52px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  background: #ebebeb;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n  color: #808080;\n  cursor: pointer;\n}\n.nextButton {\n  max-width: 250px;\n  min-width: 200px;\n  height: 52px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  background: #cb9c2d;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.disabledBtn {\n  cursor: not-allowed !important;\n  background: #cbba92 !important;\n}\n\n@media (max-width: 768px) {\n  .djelatnici-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .userMenu {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .cancelButton,\n  .nextButton {\n    max-width: 80%;\n    padding: 12px;\n  }\n  .selectContainer {\n    display: none;\n  }\n  .userMenu {\n    display: none; /* needs to be added back later */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexContainer": `AddEmployeeToGroup_flexContainer__zRQJg`,
	"button": `AddEmployeeToGroup_button__g5Pae`,
	"icon": `AddEmployeeToGroup_icon__u4EdB`,
	"title": `AddEmployeeToGroup_title__ZjNFw`,
	"userMenu": `AddEmployeeToGroup_userMenu__uJ7Yd`,
	"djelatnici-grid": `AddEmployeeToGroup_djelatnici-grid__St1Ka`,
	"buttonContainer": `AddEmployeeToGroup_buttonContainer__BeIp4`,
	"cancelButton": `AddEmployeeToGroup_cancelButton__JMSsn`,
	"nextButton": `AddEmployeeToGroup_nextButton__Z30lB`,
	"disabledBtn": `AddEmployeeToGroup_disabledBtn__U05zT`,
	"selectContainer": `AddEmployeeToGroup_selectContainer__OCpQ4`
};
export default ___CSS_LOADER_EXPORT___;
